import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import qs from 'query-string';

import Button from '@starbucks-web/pattern-library/lib/components/button';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import check from '@starbucks-web/pattern-library/lib/icons/check';

import H1 from 'shared/app/components/h1';
import { communicationPreferencesTopicsSelector } from 'shared/app/state/selectors/config';

import { preferencesMessages } from 'shared/app/messages';
import messages from './messages';

export const Successful = ({ communicationPreferencesUrl }) => {
  const { type: unsubscribeEmailType } = qs.parse(window?.location?.search);

  const communicationPreferencesTopics = useSelector(
    communicationPreferencesTopicsSelector
  );

  const communicationPreferencesLink = (
    <Button
      className="px0 py1"
      href={communicationPreferencesUrl}
      visualStyle="textLink"
    >
      <FormattedMessage {...preferencesMessages.communicationPreferencesLink} />
    </Button>
  );

  const emailTypeMessage =
    unsubscribeEmailType ===
    communicationPreferencesTopics.sbuxPersonalizedEmail ? (
      <FormattedMessage {...messages.personalizedEmailsHeading} />
    ) : (
      <FormattedMessage {...messages.promotionalEmailsHeading} />
    );

  return (
    <React.Fragment>
      <H1 className="py4" size="md">
        {emailTypeMessage}
        <span className="pl2">
          <Icon className="color-greenAccent" path={check} />
        </span>
      </H1>
      <p className="color-textBlackSoft">
        <FormattedMessage {...messages.partingMessage} />
      </p>
      <p className="py4 color-textBlackSoft">
        <FormattedMessage
          {...preferencesMessages.accountHoldersLink}
          values={{ communicationPreferencesLink }}
        />
      </p>
    </React.Fragment>
  );
};

export default Successful;
